import React, { useRef } from 'react';
import { SponsoredBrandItemWithClickEvent } from './brands-item';
import { useSponsoredBrandsEvents } from 'common/hooks';

export interface SponsoredBrandItemProps {
  brand: {
    pictureUrl: string;
    targetUrl: string;
  };
  id: string;
  searchQuery: string;
  isInViewport: boolean;
}

export function SponsoredBrandItem(props: SponsoredBrandItemProps) {
  const { id, searchQuery, isInViewport } = props;

  const brandRef = useRef<HTMLDivElement | null>(null);

  const { handleClickEvent } = useSponsoredBrandsEvents({
    brandRef,
    contentId: id,
    searchQuery,
    isInViewport,
  });

  return (
    <SponsoredBrandItemWithClickEvent
      ref={brandRef}
      onPointerUpWithoutScroll={handleClickEvent}
      key={id}
      {...props}
    />
  );
}
